import React from "react";

import { Button as AntButton, ButtonProps as AntButtonProps } from "antd";

import { goTo, trackMixpanel, useNavigate } from "utils";

export type LinkProps = Omit<AntButtonProps, "type"> & {
  dataTestId?: string;
  mixpanelText?: string;
  to?: string;
  type?: "primary-link" | "secondary-link" | "tertiary-link";
  tracking?: boolean;
};

export const Link = ({ dataTestId, children, className, mixpanelText, target, to, type, onClick, tracking = true, ...props }: LinkProps) => {
  const navigate = useNavigate();

  return (
    <AntButton
      {...props}
      data-testid={dataTestId}
      href={to}
      type="link"
      className={className ?? type}
      onClick={(e) => {
        if (tracking) {
          trackMixpanel("ClickLink", {
            linkText: mixpanelText || (typeof children === "string" && children) || "undefined",
            link: to,
          });
        }
        if (to) {
          goTo(e, navigate, to, target && target === "_blank");
        }
        onClick?.(e);
      }}
    >
      {children}
    </AntButton>
  );
};

export default Link;
